import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const serviceTypesUrl = `${apiUrl}serviceTypes`;

export const serviceTypesGet = (includeInActives) =>
    axios.get(`${serviceTypesUrl}?includeInactive=${includeInActives}`);

export const serviceTypesGetById = (id) =>
    axios.get(`${serviceTypesUrl}/${id}`);

export const serviceTypeCreate = (data) =>
    axios.post(`${serviceTypesUrl}`, data);

export const serviceTypeUpdate = (id, data) =>
    axios.put(`${serviceTypesUrl}/${id}`, data);

export const serviceTypeDelete = (id) =>
    axios.delete(`${serviceTypesUrl}/${id}`);
